'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var required = exports.required = function required() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'This field is required';

  return function (val) {
    switch (typeof val === 'undefined' ? 'undefined' : _typeof(val)) {
      case 'string':
        return !val.trim() && msg;
      default:
        return !val && msg;
    }
  };
};

var email = exports.email = function email() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Please enter a valid email';

  return function (val) {
    return !!val && !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val) && msg;
  };
};

var phone = exports.phone = function phone() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Please enter a valid phone number';

  var phoneRegex = /^\({0,1}((0|\+61)(2|4|3|7|8)){0,1}\){0,1}( |-){0,1}[0-9]{2}( |-){0,1}[0-9]{2}( |-){0,1}[0-9]{1}( |-){0,1}[0-9]{3}$/;
  return function (val) {
    return !!val && !phoneRegex.test(val.replace(/\s/g, '')) && msg;
  };
};

var url = exports.url = function url() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Please enter a valid URL';

  var urlRegex = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
  return function (val) {
    return !!val && !urlRegex.test(val) && msg;
  };
};

var slug = exports.slug = function slug() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Please enter a valid URL using only letters, numbers or hyphens (-)';

  return function (val) {
    return !!val && !/^[A-Za-z0-9-]+$/i.test(val) && msg;
  };
};

var number = exports.number = function number() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Must be a number';

  return function (val) {
    return !!val && isNaN(val) && msg;
  };
};

var alphaNumeric = exports.alphaNumeric = function alphaNumeric() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Field must be only letters or numbers';

  return function (val) {
    return !!val && !/^[A-Za-z0-9]+$/i.test(val) && msg;
  };
};

var alpha = exports.alpha = function alpha() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Field must be only letters';

  return function (val) {
    return !!val && !/^[A-Za-z]+$/i.test(val) && msg;
  };
};

var alphaNumericSpecial = exports.alphaNumericSpecial = function alphaNumericSpecial() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'No special characters allowed';

  return function (val) {
    return !!val && !/^[A-Za-z0-9'_./#&+-\s]+$/i.test(val) && msg;
  };
};

var equals = exports.equals = function equals(value) {
  var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Field must be equal to ' + value;

  return function (val) {
    return !!val && val !== value && msg;
  };
};

var equalsField = exports.equalsField = function equalsField(field) {
  var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Field must be equal to ' + field;

  return function (val, values) {
    return !!val && val !== values[field] && msg;
  };
};

var greaterThan = exports.greaterThan = function greaterThan() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var msg = arguments[1];

  return function (val) {
    switch (typeof val === 'undefined' ? 'undefined' : _typeof(val)) {
      case 'undefined':
        return val;
      case 'number':
        return val <= min && (msg || 'Number must be greater than ' + min);
      default:
        return !!val && val.length <= min && (msg || 'Must have a length greater than ' + min);
    }
  };
};

var greaterThanOrEqualTo = exports.greaterThanOrEqualTo = function greaterThanOrEqualTo() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var msg = arguments[1];

  return function (val) {
    switch (typeof val === 'undefined' ? 'undefined' : _typeof(val)) {
      case 'undefined':
        return val;
      case 'number':
        return val < min && (msg || 'Number must be greater than or equal to ' + min);
      default:
        return !!val && val.length < min && (msg || 'Must have a length greater than or equal to ' + min);
    }
  };
};

var lessThan = exports.lessThan = function lessThan() {
  var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var msg = arguments[1];

  return function (val) {
    switch (typeof val === 'undefined' ? 'undefined' : _typeof(val)) {
      case 'undefined':
        return val;
      case 'number':
        return val >= max && (msg || 'Number must be less than ' + max);
      default:
        return !!val && val.length >= max && (msg || 'Must have a length less than ' + max);
    }
  };
};

var lessThanOrEqualTo = exports.lessThanOrEqualTo = function lessThanOrEqualTo() {
  var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var msg = arguments[1];

  return function (val) {
    switch (typeof val === 'undefined' ? 'undefined' : _typeof(val)) {
      case 'undefined':
        return val;
      case 'number':
        return val > max && (msg || 'Number must be less than or equal to ' + max);
      default:
        return !!val && val.length < max && (msg || 'Must have a length less than or equal to ' + max);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/lib/validators/index.js
// module id = 79
// module chunks = 0